var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "drive-explorer" },
    [
      _c("div", { staticClass: "drive-header" }, [
        _c(
          "div",
          { staticClass: "tabs" },
          [
            _c(
              "a-radio-group",
              {
                attrs: { "button-style": "solid" },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "myDrive" } }, [
                  _vm._v(_vm._s(_vm.$t("googleDrive.myDrive"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "sharedDrives" } }, [
                  _vm._v(_vm._s(_vm.$t("googleDrive.sharedDrives"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-input-search", {
              staticStyle: { width: "300px" },
              attrs: {
                placeholder: _vm.$t("googleDrive.searchFiles"),
                allowClear: "",
              },
              on: { search: _vm.handleSearch },
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button-group",
              [
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: _vm.viewMode === "grid" ? "primary" : "default",
                    },
                    on: {
                      click: function ($event) {
                        _vm.viewMode = "grid"
                      },
                    },
                  },
                  [_c("a-icon", { attrs: { type: "appstore" } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: {
                      type: _vm.viewMode === "list" ? "primary" : "default",
                    },
                    on: {
                      click: function ($event) {
                        _vm.viewMode = "list"
                      },
                    },
                  },
                  [_c("a-icon", { attrs: { type: "bars" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.activeTab === "myDrive" && !_vm.isSearchMode
        ? _c(
            "div",
            { staticClass: "breadcrumb-container" },
            [
              _c(
                "a-breadcrumb",
                [
                  _c("a-breadcrumb-item", [
                    _c(
                      "a",
                      { on: { click: _vm.navigateToRoot } },
                      [_c("a-icon", { attrs: { type: "home" } })],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.breadcrumbs, function (folder) {
                    return _c("a-breadcrumb-item", { key: folder.id }, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.navigateToFolder(
                                folder.id,
                                folder.name
                              )
                            },
                          },
                        },
                        [_vm._v(_vm._s(folder.name))]
                      ),
                    ])
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.activeTab === "sharedDrives" && !_vm.selectedDriveId
        ? _c("div", { staticClass: "shared-drives-list" }, [
            _vm.loadingDrives
              ? _c("div", { staticClass: "loading" }, [_c("a-spin")], 1)
              : _c(
                  "div",
                  { staticClass: "drives-grid" },
                  [
                    _vm._l(_vm.sharedDrives, function (drive) {
                      return _c(
                        "div",
                        {
                          key: drive.id,
                          staticClass: "drive-card",
                          on: {
                            click: function ($event) {
                              return _vm.selectSharedDrive(drive)
                            },
                          },
                        },
                        [
                          _c("a-icon", {
                            staticClass: "drive-icon",
                            attrs: { type: "folder" },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "drive-name" }, [
                            _vm._v(_vm._s(drive.name)),
                          ]),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    _vm.sharedDrives.length === 0
                      ? _c(
                          "div",
                          { staticClass: "empty-state" },
                          [
                            _c("a-icon", { attrs: { type: "inbox" } }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(_vm.$t("googleDrive.noSharedDrives"))
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  2
                ),
          ])
        : _c(
            "div",
            { staticClass: "files-container" },
            [
              _vm.loading
                ? _c("div", { staticClass: "loading" }, [_c("a-spin")], 1)
                : [
                    _vm.viewMode === "grid"
                      ? _c(
                          "div",
                          { staticClass: "files-grid" },
                          _vm._l(_vm.files, function (file) {
                            return _c(
                              "div",
                              {
                                key: file.id,
                                staticClass: "file-card",
                                class: {
                                  selected: _vm.isSelected(file),
                                  folder: _vm.isFolder(file),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleFileClick($event, file)
                                  },
                                  dblclick: function ($event) {
                                    return _vm.handleFileDblClick($event, file)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "file-icon" },
                                  [
                                    _vm.isFolder(file)
                                      ? _c("a-icon", {
                                          attrs: {
                                            type: "folder",
                                            theme: "filled",
                                          },
                                        })
                                      : file.thumbnailLink
                                      ? _c("img", {
                                          attrs: { src: file.thumbnailLink },
                                        })
                                      : _c("a-icon", {
                                          attrs: {
                                            type: _vm.getFileIcon(
                                              file.mimeType
                                            ),
                                          },
                                        }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "file-name",
                                    attrs: { title: file.name },
                                  },
                                  [_vm._v(_vm._s(file.name))]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "file-meta" }, [
                                  file.size
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.formatBytes(file.size))
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          }),
                          0
                        )
                      : _c("a-table", {
                          attrs: {
                            columns: _vm.columns,
                            "data-source": _vm.files,
                            "row-key": function (record) {
                              return record.id
                            },
                            pagination: false,
                            "row-selection": {
                              selectedRowKeys: _vm.selectedFiles,
                              onChange: _vm.onSelectChange,
                            },
                            customRow: _vm.customRow,
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "name",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "file-name-cell" },
                                    [
                                      _vm.isFolder(record)
                                        ? _c("a-icon", {
                                            staticClass: "folder-icon",
                                            attrs: {
                                              type: "folder",
                                              theme: "filled",
                                            },
                                          })
                                        : record.thumbnailLink
                                        ? _c("img", {
                                            staticClass: "thumbnail",
                                            attrs: {
                                              src: record.thumbnailLink,
                                            },
                                          })
                                        : _c("a-icon", {
                                            staticClass: "file-type-icon",
                                            attrs: {
                                              type: _vm.getFileIcon(
                                                record.mimeType
                                              ),
                                            },
                                          }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v(_vm._s(text))]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "size",
                              fn: function (text) {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        text ? _vm.formatBytes(text) : "-"
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "modifiedTime",
                              fn: function (text) {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.formatDate(text)) +
                                      "\n                "
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                    _vm._v(" "),
                    _vm.files.length === 0 && !_vm.loading
                      ? _c(
                          "div",
                          { staticClass: "empty-state" },
                          [
                            _c("a-icon", { attrs: { type: "inbox" } }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(_vm._s(_vm.$t("googleDrive.noFiles"))),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
              _vm._v(" "),
              _vm.nextPageToken && !_vm.loading
                ? _c(
                    "div",
                    { staticClass: "load-more" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { loading: _vm.loadingMore },
                          on: { click: _vm.loadMore },
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("googleDrive.loadMore")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
      _vm._v(" "),
      _vm.selectedFiles.length > 0
        ? _c(
            "div",
            { staticClass: "selection-actions" },
            [
              _c("span", [
                _vm._v(
                  _vm._s(_vm.selectedFiles.length) +
                    " " +
                    _vm._s(_vm.$t("googleDrive.filesSelected"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.downloading },
                  on: { click: _vm.downloadSelected },
                },
                [
                  _c("a-icon", { attrs: { type: "download" } }),
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("googleDrive.downloadToSupsis")) +
                      "\n        "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("a-button", { on: { click: _vm.clearSelection } }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.cancel")) +
                    "\n        "
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("FilePreviewModal", {
        attrs: {
          visible: _vm.previewVisible,
          files: _vm.previewableFiles,
          "initial-index": _vm.previewIndex,
          "channel-id": _vm.channel._id,
        },
        on: { close: _vm.closePreview, downloaded: _vm.onFileDownloaded },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }